import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { CircularProgress } from 'material-ui/Progress';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { slice } from 'lodash'

import filter from 'lodash/filter'

import * as addSubDecision from '../../../actions/decisiondetails';
import * as toaster from '../../../actions/toaster';

import MultiSelect from '../../multiselect'
import * as regData from '../../../../appConstants'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class AddSubDecision extends Component {
    state = {
        open: false,
        setValue: false,
        setPostValue: false,
        addSubDecision: {
            id: 0,
            decision_text: '',
            decision_no: '',
            decision_status: '',
            decision_status_desc: '',
            AssigneeIds: [],
        }
    };

    componentDidMount() {
    }
    handleChange(field, e) {
        if (field == 'decision_status') {
            let filVal = filter(this.props.decisionlookup, { id: e.target.value })
            let desc = filVal.length > 0 ? filVal[0].status_text : '';
            const addSubDecision = Object.assign({}, this.state.addSubDecision, { [field]: e.target.value, 'decision_status_desc': desc });
            this.setState(Object.assign({}, this.state, { 'addSubDecision': addSubDecision }));
        }
        else {
            const addSubDecision = Object.assign({}, this.state.addSubDecision, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'addSubDecision': addSubDecision }));
        }
    }
    handleMultiSelectChange = event => {
        let newaddSubDecision = Object.assign({}, this.state.addSubDecision);
        slice(newaddSubDecision.AssigneeIds, 0, newaddSubDecision.AssigneeIds.length)
        newaddSubDecision.AssigneeIds = event.target.value;
        this.setState({ addSubDecision: newaddSubDecision });
        // console.log(newaddSubDecision)
    };
    handleRequestClose = () => {
        this.state.setValue = false;
        // console.log('this.props.data test', this.state.setValue)
        this.setState({ setValue: false })
        this.state.addSubDecision = {
            id: 0,
            AssigneeIds: [],
        }
        this.props.handleRequestClose()
    };
    setDataSubDecision = () => {
        // e.preventDefault();

        if (!this.state.addSubDecision.decision_status || this.state.addSubDecision.decision_status == '')
            this.props.actions.errorToasters("Please select a Status");
        else if (!this.state.addSubDecision.AssigneeIds || this.state.addSubDecision.AssigneeIds.length == 0)
            this.props.actions.errorToasters("Please select an Assignee");
        else {
            if (this.state.addSubDecision.id && this.state.addSubDecision.id > 0) {
                this.props.actions.updateSubDecisionDetails(this.state.addSubDecision)
                this.setState({ setPostValue: true })
            }
            else {
                this.addSubDecisionParentCall();
            }
        }
    };
    addSubDecisionParentCall() {
        this.props.setAddSubDecision(this.state.addSubDecision);
        this.setState({ setPostValue: false })
        this.state.addSubDecision = {
            id: 0,
            AssigneeIds: [],
        }
        this.handleRequestClose();
    }
    render() {
        const { data, assigneeUserList, decisionDetails, decisionlookup } = this.props;
        let result = null;
        // console.log('this.state.setValue', this.state.setValue)
        if (decisionDetails && decisionDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (data && data.id && !this.state.setValue) {
            this.state.addSubDecision = data;
            this.setState({ addSubDecision: data })
            this.setState({ setValue: true })
        }
        if (decisionDetails && !decisionDetails.Status && decisionDetails.apiPostResult && this.state.setPostValue) {
            this.addSubDecisionParentCall();
            this.setState({ setPostValue: false })
        }
        // console.log('this.state.addSubDecision', this.state.addSubDecision)
        let _StatusList = null
        // console.log('AddRole TeamList', decisionlookup)
        const statusList = decisionlookup;
        if (statusList && statusList.length > 0) {
            _StatusList = statusList.map(status => (
                <MenuItem key={status.id} value={status.id}
                    style={{ fontWeight: '400', }}>
                    {status.status_text}
                </MenuItem>
            ))
        }
        let _AssigneeUserList = null
        if (this.props.assigneeUserList && this.props.assigneeUserList.length > 0) {
            _AssigneeUserList = this.props.assigneeUserList.map(user => ({ value: user.id, label: user.name }))
        }
        return (
            <div>
                {/* {console.log(this.refs.subdecision)} */}
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Add Sub Decision</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <ValidatorForm autoComplete="off" ref="subdecisionform" onSubmit={this.setDataSubDecision.bind(this)}>
                            <div className="row p-4">
                                <div className="col-12 pb-4">
                                    <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                        name="decision_text" label="Decision Text" multiline={true}
                                        validators={['required',regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                        errorMessages={['This field is required',regData.messageMultilineRegexEx,regData.messageMultilineLength]}
                                        value={this.state.addSubDecision.decision_text} onChange={this.handleChange.bind(this, 'decision_text')} />
                                </div>
                                <div className="col-4 pb-4">
                                    <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                        name="decision_no" label="Decision Number"
                                        validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                        errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                        value={this.state.addSubDecision.decision_no} onChange={this.handleChange.bind(this, 'decision_no')} />
                                </div>
                                <div className="col-4 pb-4">
                                    <FormControl className="w-100 mb-2 col-12">
                                        <InputLabel htmlFor="age-simple">Select Status</InputLabel>
                                        <Select value={Number(this.state.addSubDecision.decision_status ? this.state.addSubDecision.decision_status : 0)}
                                            onChange={this.handleChange.bind(this, 'decision_status')}
                                            input={<Input id="age-simple" />} >
                                            {_StatusList}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-12 pb-4" style={{ height: '250px' }}>
                                    <MultiSelect label="Add Assignee" options={_AssigneeUserList}
                                        onChange={(data) => { this.state.addSubDecision.AssigneeIds = data[0] == 0 ? [] : data }}
                                        value={this.state.addSubDecision.AssigneeIds} />
                                </div>
                            </div>
                        </ValidatorForm>
                    </DialogContent>
                    <DialogActions className="text-right">
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={() => this.refs.subdecisionform.submit()} variant="raised" className="jr-btn bg-primary text-white">
                            {this.state.addSubDecision && this.state.addSubDecision.id > 0 ? "Save" : "Add"}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, addSubDecision, toaster), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddSubDecision);


// WEBPACK FOOTER //
// ./app/decisiondetails/adddecision/addsubdecision.js